import React, { Component } from 'react';
import { connect } from "react-redux";




@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class Required extends Component {

    constructor(props) {
        super(props);

    }

    componentDidMount() {

    }

    render() {
        const { t } = this.props;
        return (
            <React.Fragment>
                <div className="required_checkbox" onClick={() => this.props.changeRequired(this.props.index)}>
                    <div className="label-container">
                        <div>
                            <input type="checkbox" className="hv-checkbox"  checked={this.props.is_required} />
                        </div>
                        <div className="checkbox-text">
                            Required
                        </div>


                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default Required;
